/* eslint-disable no-unused-vars */
export enum FrequencyLimitUnitsForResend{
    Hour = 'HOUR'
}

export enum FrequencyLimitUnitsWithoutPlural{
    Hour = 'HOUR',
    Month = 'MONTH',
    Week = 'WEEK',
    Year = 'YEAR',
}
export enum FrequencyLimitUnits {
    Hour = 'HOURS',
    Month = 'MONTHS',
    Week = 'WEEKS',
    Year = 'YEARS',
}

export const FrequencyLimitUnitLabels: { [key: string]: string } = {
    [FrequencyLimitUnits.Hour]: 'H',
    [FrequencyLimitUnits.Month]: 'M',
    [FrequencyLimitUnits.Week]: 'W',
    [FrequencyLimitUnits.Year]: 'Y'
};
